import FreelancerUserPaymentMethodEnum from '../../../../Enums/FreelancerUserPaymentMethodEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForChile {
  //#region  OnChange
  static onContractorLocationCountryIdChange(editedItem) {
    editedItem.PaymentMethod = EditFreelancerUserHelper.getDefaultPaymentMethodValue(editedItem);
    editedItem.PaymentCurrencyId = EditFreelancerUserHelper.getDefaultPaymentCurrencyValue(editedItem);
  }
  //#endregion

  //#region selectValues
  static getCurrencySelectValues(editedItem) {
    if (editedItem.ContractorLocationCountryId?.toString() === '44') {
      return [29];
    } else {
      return [151];
    }
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'Chile Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 7),
      fields: [
        {
          fieldName: (item) => item.PaymentCurrencyId,
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: PaymentInformationForChile.getCurrencySelectValues,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'ContractorLocationCountryId',
          label: 'Contractor Location',
          className: 'col-6',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          onFieldChange: PaymentInformationForChile.onContractorLocationCountryIdChange,
        },
        {
          fieldName: 'PIBankNameAndCode',
          label: 'Bank Name and Code',
          className: 'col-6',
          type: InputTypesEnum.ChileBankNameCodeLookupSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Account Holder Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.BankTransfer,
              FreelancerUserPaymentMethodEnum.WesternUnion,
            ]),
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: 'Bank Account Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIPaypalWiseWesternUnionEmail',
          label: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.PayPal ? 'PayPal Email' : 'Western Union Email',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forEmailRequired,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.PayPal,
              FreelancerUserPaymentMethodEnum.WesternUnion,
            ]),
        },
        {
          fieldName: 'PICPFRUT',
          label: 'RUT',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.PayPal,
              FreelancerUserPaymentMethodEnum.WesternUnion,
              FreelancerUserPaymentMethodEnum.BankTransfer,
            ]),
        },
        {
          fieldName: 'PIWesternUnionAddress',
          label: 'Western Union Address',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.WesternUnion),
        },
      ],
    };
  }
}
